import { RIGHT_ADDON_OPTIONS } from './options.js';

var defaultProps = {
  rightAddon: RIGHT_ADDON_OPTIONS.InvisibleHide,
  mask: function mask(data) {
    return new Array(data.length).fill(/./);
  }
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
